<div [ngClass]="{'form-error' : formError}" class="card mt-5">
    <div class="card-header">
        <span class="card-header__name">{{translatePath+'summary' | translate }}</span>
        <hr>
    </div>
    <div class="card-body pb-0 mb-0">
        <div *ngFor="let products of groupByProducts;let i = index">
            <div *ngFor="let item of products;let i = index">
                <div *ngIf="i==0" class="row d-flex flex-row align-content-start justify-content-between col-12 ">
                    <span class="subtotal"><b>{{ item.name }}</b></span>
                    <span class="order"><b>{{ products.length }} {{translatePath+'units' | translate }}</b></span>
                </div>
            </div>
        </div>
        <hr class="border-grey w-auto my-2">

        <div class="row d-flex flex-row align-content-start justify-content-between col-12  pb-2">
            <span class="subtotal">{{translatePath+'subtotal'| translate}}</span>
            <span *ngIf="order" class="price"><b>{{getSubtotal()}} MDL</b></span>
        </div>


        <div class="row d-flex flex-row align-content-start justify-content-between col-12  pb-2">
            <span class="shipping">{{translatePath+'shipping-price'| translate}}</span>
            <span class="price"><b>{{option?(option.cost+ ' MDL'):('-'| translate)}} </b></span>
        </div>


        <div class="row d-flex flex-column flex-row col-12">
            <span class="d-flex justify-content-between">
                <span class="primary align-self-start"><b>{{translatePath+'total'| translate}}</b></span>
                <span>
                    <b>{{option?(getTotalPrice()+ ' MDL'):('-' | translate)}} </b>
                </span>
            </span>
            <div class="align-self-end alert alert-warning mt-3 mb-0 w-100" *ngIf="!option" [innerHtml]="translatePath+'next-step-calc'| translate">
            </div>
        </div>
    </div>
</div>

